import { TeamDashboardAPI } from 'api';
import { TInfiniteQuery } from 'api/api.types';
import { useInfiniteQuery, useQuery, useQueryClient } from 'react-query';

export const useGetDashboardFilterEnums = () => {
  return useQuery(
    ['team-dashboard-filter-enums'],
    () => TeamDashboardAPI.getTeamDashboardFilterEnums(),
    {
      staleTime: 0
    }
  );
};

export const useTeamRequests = ({ args, ...config }: TInfiniteQuery = {}) => {
  const queryClient = useQueryClient();

  const { viewId, ...rest } = args || {};

  const queryFn = async ({ pageParam = 1 }) => {
    const { items, ...headers } = await TeamDashboardAPI.getTeamRequestsList(
      { ...rest, pageNumber: pageParam },
      viewId
    );

    queryClient.setQueryData(
      ['team-requests-headers', { id: args?.id, viewId: args?.viewId }],
      headers
    );

    return items;
  };

  return useInfiniteQuery(['team-requests', args], queryFn, {
    staleTime: 1000 * 60 * 5,
    getNextPageParam: (_, allPages) => allPages.length + 1,
    keepPreviousData: true,
    refetchInterval: 1000 * 60 * 5,
    cacheTime: 0,
    ...config
  });
};
